import { render, staticRenderFns } from "./TURNOVER.vue?vue&type=template&id=08894976&"
import script from "./TURNOVER.vue?vue&type=script&lang=js&"
export * from "./TURNOVER.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports